import React from "react";
import { motion } from "framer-motion";
import { BookMarked, Search, Flag } from "lucide-react";
import Ebook3D from "./Ebook3D";
import { startCheckout } from "@/lib/checkout";

const benefits = [
  {
    icon: BookMarked,
    title: "Conteúdo organizado",
    desc: "Informações reunidas em uma estrutura cronológica, do primeiro mandato à decisão do STF.",
    num: "01",
  },
  {
    icon: Search,
    title: "Abordagem documental",
    desc: "Referências e fontes para aprofundamento — autos processuais, imprensa e documentos públicos.",
    num: "02",
  },
  {
    icon: Flag,
    title: "Contexto histórico",
    desc: "Uma visão organizada dos acontecimentos da política brasileira recente — fatos, acusações e decisões.",
    num: "03",
  },
];

export default function Product() {
  return (
    <section className="relative bg-[#070707] py-24 md:py-36 border-t border-white/5">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-7">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="flex items-center gap-3 mb-6"
          >
            <span className="h-[1px] w-10 bg-red-600" />
            <span className="eyebrow">Capítulo zero · Sobre o dossiê</span>
          </motion.div>

          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
            className="font-display font-black text-neutral-50 leading-[0.95] tracking-[-0.02em] text-4xl sm:text-5xl lg:text-[72px]"
          >
            Um dossiê sobre os fatos que{" "}
            <span className="text-red-600 italic">marcaram</span> a política brasileira.
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2, duration: 0.8 }}
            className="mt-8 max-w-xl text-neutral-400 text-[15px] md:text-base leading-relaxed"
          >
            Reunimos acontecimentos, investigações, decisões judiciais e controvérsias em uma
            narrativa cronológica e organizada, permitindo compreender o contexto por trás das
            principais manchetes.
          </motion.p>

          <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-4">
            {benefits.map((b, i) => (
              <motion.div
                key={b.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.12, duration: 0.7 }}
                className="relative p-6 border border-white/10 hover:border-red-600/60 transition-colors bg-[#0b0b0b] group"
              >
                <div className="font-mono text-[9px] tracking-[0.3em] text-red-500 mb-6">
                  {b.num} / 03
                </div>
                <button
                  type="button"
                  onClick={startCheckout}
                  aria-label={`Comprar ebook — ${b.title}`}
                  className="h-10 w-10 inline-flex items-center justify-center border border-white/10 text-neutral-300 hover:border-red-600 hover:text-red-500 transition-colors mb-5"
                >
                  <b.icon className="h-5 w-5" />
                </button>
                <h3 className="font-display text-xl text-neutral-50 mb-2">{b.title}</h3>
                <p className="text-[13px] text-neutral-500 leading-relaxed">{b.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5 flex items-center justify-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.85, rotate: -3 }}
            whileInView={{ opacity: 1, scale: 1, rotate: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
          >
            <Ebook3D />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
